import React, { ReactElement } from 'react';

import { SocialLinks } from '@components/Social';
import { Author } from '@interfaces/Author';

export function AuthorSocialLinks({
  author,
}: {
  author: Author;
}): ReactElement {
  return (
    <SocialLinks
      name={author.name}
      noFollow={author.noFollow ?? false}
      facebook={author.facebook}
      instagram={author.instagram}
      twitter={author.twitter}
      tiktok={author.tiktok}
      linkedIn={author.linkedIn}
      website={author.website}
      youTube={author.youTube}
    />
  );
}
